"use client";
import PageContainer from "@/app/admin/_common/PageContainer";
import PageHeader from "@/app/admin/_common/PageHeader";
import CuoButton from "@/app/admin/_common/CuoButton";
import { usePromosModel } from "./promosPageModel";
import PromosToolbar from "./_cmp/PromosToolbar";
import PromoList from "./_cmp/PromoList";
import PromoListSkeleton from "./_cmp/PromoListSkeleton";
import { PromoDialog } from "./_cmp/promoForm/PromoDialog";
import { PlusCircle, Tag } from "lucide-react";
import { useIsMobile } from "@/app/admin/_hooks/useIsMobile";

export default function PromosPage() {
  const isMobile = useIsMobile();
  const {
    filteredPromos,
    showOptions,
    showMap,
    isShowMapLoading,
    isLoading,
    search,
    setSearch,
    statusFilter,
    setStatusFilter,
    selectedPromo,
    openForm,
    openCreateForm,
    openEditForm,
    closeForm,
    handleToggleActive,
    handleDelete,
    refetch,
  } = usePromosModel();

  const addButton = (
    <CuoButton
      variant={isMobile ? "outline" : "default"}
      label={<span className="hidden sm:inline">Add promo code</span>}
      icon={<PlusCircle className="size-3.5 shrink-0" size={14} />}
      onClick={openCreateForm}
      className="px-2 sm:px-3"
      aria-label="Add promo code"
    />
  );

  const toolbar = (
    <PromosToolbar
      search={search}
      onSearchChange={setSearch}
      statusFilter={statusFilter}
      onStatusChange={setStatusFilter}
    />
  );

  const list = isLoading ? (
    <PromoListSkeleton />
  ) : (
    <PromoList
      promos={filteredPromos}
      showMap={showMap}
      isShowMapLoading={isShowMapLoading}
      onEdit={openEditForm}
      onToggleActive={handleToggleActive}
      onDelete={handleDelete}
    />
  );

  const dialog = (
    <PromoDialog
      open={openForm}
      defaultPromo={selectedPromo}
      showOptions={showOptions}
      onClose={closeForm}
      onSaved={refetch}
    />
  );

  if (isMobile) {
    return (
      <PageContainer flush>
        <div className="flex h-full w-full flex-col overflow-y-auto">
          <div className="sticky top-0 z-10 flex flex-col gap-2 border-b border-border bg-card/80 px-3 py-2 backdrop-blur-sm">
            <PageHeader
              title="Promo Codes"
              icon={Tag}
              subtitle={`${filteredPromos.length} promo codes`}
              actions={addButton}
              className="static bg-transparent p-0 backdrop-blur-none"
            />
            {toolbar}
          </div>

          <div className="flex flex-1 flex-col pb-3">{list}</div>
        </div>

        {dialog}
      </PageContainer>
    );
  }

  return (
    <PageContainer flush>
      <div className="flex h-full w-full flex-col">
        <PageHeader
          title="Promo Codes"
          icon={Tag}
          subtitle={`${filteredPromos.length} promo codes`}
          actions={addButton}
        />

        <div className="flex min-h-0 flex-1 flex-col gap-3 px-5 py-5">
          {toolbar}

          <div className="flex min-h-0 flex-1 flex-col">{list}</div>
        </div>
      </div>

      {dialog}
    </PageContainer>
  );
}
